import { Component, inject } from "@angular/core";

import { PageComponent, PlanTableComponent } from "@shared/components";
import { GlobalService } from "@shared/services";

@Component({
  selector: "app-active-plan",
  standalone: true,
  imports: [PageComponent, PlanTableComponent],
  templateUrl: "./active-plan.component.html",
  styleUrl: "./active-plan.component.scss",
})
export class ActivePlanComponent {
  globalService = inject(GlobalService);

  getTableHeight(): string {
    return `calc(100vh - ${this.globalService.navbarHeight()}px - 150px)`;
  }
}
